<button class="chatbot-toggler" (click)="openCloseBot()"> 
    <span class="material-symbols-rounded" ><mat-icon>chat_bubble</mat-icon></span>
    <span class="material-symbols-outlined"><mat-icon>close</mat-icon></span>
  </button>
  <div class="chatbot">
    <header>
      <h2>Chatbot</h2>
      <span class="close-btn material-symbols-outlined">close</span>
    </header>
    <ul class="chatbox">
      <li class="chat incoming">
        <span class="material-symbols-outlined"><mat-icon>smart_toy</mat-icon></span>
        <p>Hi there 👋<br>How can I help you today?</p>
      </li>
    </ul>
    <div class="chat-input">
      
      <form [formGroup]="postMessageForm" (ngSubmit)="postMessage($event)" (keydown)="postMessage($event)" >
        <input placeholder="Enter a message..." formControlName="message" spellcheck="false" required/>
        <div class=""><button mat-stroked-button class="material-symbols-rounded" [disabled]="postMessageForm.invalid" >send</button></div>
      </form>
    </div>
  </div>